import { ChevronRight } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";
import { SidebarMenuButton } from "@/components/ui/sidebar";
import { NavMainItem } from "../Interface/NavBar";
import { NavItemIcon } from "./nav-icon";

// Button for the sub-menu itself
export const SubmenuLink = React.forwardRef<
	HTMLAnchorElement,
	{ item: NavMainItem } & React.AnchorHTMLAttributes<HTMLAnchorElement>
>(({ item, ...props }, ref) => (
	<Link to={item.url} ref={ref} {...props}>
		<NavItemIcon icon={item.icon} />
		<span>{item.title}</span>
	</Link>
));
SubmenuLink.displayName = "SubmenuLink";

// Main Parent Button For the NavBar
export function NavBarMenuButton({
	item,
	onClick,
}: {
	item: NavMainItem;
	onClick?: React.MouseEventHandler<HTMLButtonElement>;
}) {
	return (
		<SidebarMenuButton tooltip={item.title} onClick={onClick}>
			<NavItemIcon icon={item.icon} />
			<span>{item.title}</span>
			<ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
		</SidebarMenuButton>
	);
}
